export default __webpack_public_path__ + "static/media/process-customer_EN.9843ee1b.jpg";